import React from 'react'
import PropTypes from 'prop-types'
import Immutable from 'seamless-immutable'
import styleguide from 'styleguide'

const stylingType = Immutable.from({
  label: {
    color: 'white',
    fontSize: '12px',
    textAlign: 'center',
    padding: '3px 10px',
    width: 'auto',
    backgroundColor: styleguide.color.blue,
    position: 'absolute',
  },
  icon: {
    padding: '5px',
    background: 'transparent',
    position: 'absolute',
  },
})

const stylingPosition = Immutable.from({
  topLeft: {
    left: '0',
    top: '0',
    borderTopLeftRadius: '4px',
  },
  topRight: {
    right: '0',
    top: '0',
    borderTopRightRadius: '4px',
  },
  bottomLeft: {
    left: '0',
    bottom: '0',
    borderBottomLeftRadius: '4px',
  },
  bottomRight: {
    right: '0',
    bottom: '0',
    borderBottomRightRadius: '4px',
  },
})

export const ImageBadge = ({ type, position, text, backgroundColor, icon }) => {
  const styles = Immutable.from({
    ...stylingType[type],
    ...stylingPosition[position],
  })

  return (
    <div>
      {type === 'label' && text && <span style={{ backgroundColor, ...styles }}>{text}</span>}
      {type === 'icon' && <span style={styles}>{icon}</span>}
    </div>
  )
}

ImageBadge.propTypes = {
  type: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  text: PropTypes.string,
  backgroundColor: PropTypes.string,
  icon: PropTypes.node,
}

export default ImageBadge
